// @flow

import styled, { css } from 'styled-components';
import media from '../../../helpers/media';
import type { Theme } from '../../../types';
import Tooltip from '../../tooltip/atoms/tooltip.styled';

export default styled<any, Theme>('dl')`
  padding-top: 1rem;
`;

export const Row = styled<any, Theme>('div')`
  border-bottom: 1px solid ${props => props.theme.specifications.rowBorderColor};
  display: flex;
  flex-direction: row;
  padding: .5rem 0;

  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const Key = styled<any, Theme>('dt')`
  align-items: center;
  color: ${props => props.theme.specifications.keyColor};
  display: flex;
  flex-basis: 50%;
  flex-direction: row;
  flex-grow: 1;
  flex-shrink: 1;

  ${/* sc-selector */Tooltip} {
    margin-left: .5rem;
  }

  ${media.lg(css`
    flex-basis: 55%;
  `)}
`;

export const Value = styled<any, Theme>('dd')`
  color: ${props => props.theme.specifications.valueColor};
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 50%;
  margin: 0;

  ${media.lg(css`
    flex-basis: 45%;
    min-width: 150px;
  `)}
`;
